import QRCode from 'qrcode.react';
import Barcode from 'react-barcode';
import React, { Component } from 'react';
import { Button, Col, Input, Label, Modal, ModalBody, ModalHeader, Row, Table, UncontrolledTooltip, Card, CardBody, Form } from 'reactstrap';
import { getAPI, putAPI, postAPI } from '../Base/API';
import { getMultiLangEmpty, StyledCard } from '../Base/Common/CommonUIComponents';
import CustomSelect from '../Base/Common/CustomSelect';
import { handleNotification } from "../Base/Common/Notification";
import { getHotelLanguageCountry, getOrderedCountries } from "../Base/Common/CommonUIComponents";
import { getCodeGenerationTypes, getStatus, getRightVoucherId } from '../Base/Common/ReferenceDataFunctions';
import { SelectCancellationReason } from '../Base/Common/CommonUIComponents';
import { AddRedeem } from './AddRedeem';
import { PrintableVoucher } from './PrintableVoucher';
import { FormattedMessage, injectIntl } from 'react-intl';
import Authorization, { CheckAuthorization } from '../Base/Authorization';
import moment from 'moment';
import { EditClientModal } from './EditClientModal';
import RefoundModal from './RefoundModal';
import { DateRangePicker } from 'react-dates';
import NotificationCard from './NotificationCard';
import { useRef } from 'react';
import AddRechargeModal from './AddRechargeModal';
import RegistVoucherOnPmsModal from './RegistVoucherOnPmsModal';
import { RichTextView } from '../Base/EditorText';


class VoucherOperationDetails extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        this.toggleModalPrint = this.toggleModalPrint.bind(this);
        this.setLanguage = this.setLanguage.bind(this);
        this.toggleEditClient = this.toggleEditClient.bind(this);
        this.updateClientData = this.updateClientData.bind(this);
        this.toggleRefoundModal = this.toggleRefoundModal.bind(this);
        this.state = {
            block: true,
            modal: false,
            accessDenied: false,
            voucherRedeem: {},
            voucher: {},
            language: getHotelLanguageCountry(),
            editClientModal: false,
            refoundModal: false,
            registOnPmsModal: false,
            redeem: null,
            currentVoucherStatus: null, //used to save voucher status before edit
            filterHotel: '',
            filterAmount: '',
            filterStartDate: null,
            filterEndDate: null,
            filterRangeFocused: null,
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidMount() {
        window.setTimeout(
            () => {
                const lang = getHotelLanguageCountry();

                this.setState({ language: lang }, () => {
                    if (this.props.match.params.id)
                        this.getVouherDetails(this.props.match.params.id)
                });
            }, global.defaultCultureCode ? 0 : 2500
        );
    }

    toggleModal(redeem) {
        this.setState(prevState => ({
            modal: !prevState.modal,
            redeem
        }));
    }
    toggleModalPrint() {
        this.setState(prevState => ({
            modalPrint: !prevState.modalPrint
        }));
    }

    // state.language holds the flag country (GB, PT...); the API expects the language code (EN, PT...)
    getLanguageCode = () => getMultiLangEmpty().find(lang => lang.language === this.state.language)?.languageCode;

    getVouherDetails(id) {
        this.setState({ block: true });
        getAPI(result => {
            const { data, error } = result;
            var errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    if (data.errors.some(err => err.code === 'VOUVOU0046')) {
                        this.setState({ accessDenied: true, error: errorMessage, block: false });
                        return;
                    }
                    handleNotification(data);
                }
                if (data.response && data.response.length > 0) {
                    if (data.response[0]) {
                        this.setState({ 
                            voucher: data.response[0],
                            currentVoucherStatus: data.response[0].status
                        });
                    }
                }
            }
            this.setState({ error: errorMessage, block: false });
        }, `/api/Voucher/Voucher/v1/voucher/${id}?languageCode=${this.getLanguageCode()}`);
    }

    saveVoucher = (e) => {
        e.preventDefault();
        this.setState({ block: true });

        const req = {
            request: {
                id: this.state.voucher.id,
                status: this.state.voucher.status,
                validFrom: this.state.voucher.validFrom,
                validUntil: this.state.voucher.validUntil,
                notes: this.state.voucher.notes,
                issueCode: this.state.voucher.issueCode,
                rfId: this.state.voucher.rfId,
                invoiceReference: this.state.voucher.invoiceReference,
                cancellationReasonId: this.state.voucher.cancellationReasonId,
                cancellationReasonDescription: this.state.voucher.cancellationReasonDescription,
            }
        };

        putAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                handleNotification(data, <FormattedMessage id="VoucherOperationDetails.VoucherUpdatedSuccessfully" />, <FormattedMessage id="VoucherOperationDetails.Success" />);
                this.setState({ block: false, currentVoucherStatus: data.response?.[0]?.status });
            }
        }, '/api/Voucher/Voucher/v1/voucher', req);
    }

    updateFilterCombo(val, evt) {

        if (evt) {
            let name = evt.name;
            let value = val.value;

            this.setState(prevState => ({
                ...prevState,
                voucher: {
                    ...prevState.voucher,
                    [name]: value

                },
            }));

        }
    }

    viewVoucher() {
        this.setState({ modalPrint: true })
    }

    sendNotification() {
        this.setState({ block: true });
        const lang = this.state.language ? `?lang=${this.getLanguageCode()}` : ``
        postAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            handleNotification(data, <FormattedMessage id="VoucherOperationDetails.NotificationSentSuccessfully" />, <FormattedMessage id="VoucherOperationDetails.Success" />);
            this.setState({ block: false }, () => this.getVouherDetails(this.props.match.params.id));
        }, ' /api/Voucher/v1/Notification/sendVoucherNotification/' + this.state.voucher.id + lang);

    }

    onlineSaleDetail() { this.props.history.push('/OnlineSalesDetail/' + this.state.voucher.onlinePaymentId) }
    voucherTypeDetail() { this.props.history.push('/CardConfigWizard/' + this.state.voucher.voucherType.id) }

    setLanguage(country) {
        let { language } = this.state;
        if (language !== country) {
            language = country;
            this.setState({ language }, () => {
                if (this.props.match.params.id) {
                    this.getVouherDetails(this.props.match.params.id);
                }
            });
        }
    }

    editClient() {
        this.setState({ editClientModal: true });
    }

    toggleEditClient() {
        this.setState(prevState => ({ editClientModal: !prevState.editClientModal }));
    }

    updateClientData(profile) {
        const { voucher } = this.state;
        voucher.name = `${profile.firstName} ${profile.lastName}`;
        voucher.email = profile.email;
        voucher.profileId = profile.id;
        this.setState({ voucher });
    }

    toggleRefoundModal(redeem) {
        let maxQuantity = null;

        if (redeem) {
            const usage = this.state.voucher.redeems.filter(x => x.rebateId === redeem.rebateId).reduce((acc, cur) => acc + cur.quantity, 0);
            maxQuantity = usage < redeem.quantity ? usage : redeem.quantity;
        }

        this.setState(prevState => ({ refoundModal: !prevState.refoundModal, redeem: redeem, maxQuantity }));
    }

    disableServiceRefund = (redeem) => {
        let disable = true;
        const rebate = this.state.voucher.voucherType.voucherRebates.find(el => el.id === redeem.rebateId);

        if (redeem.quantity > 0 && rebate) {
            const usage = this.state.voucher.redeems.filter(x => x.rebateId === rebate.id).reduce((acc, cur) => acc + cur.quantity, 0)

            if (usage > 0) {
                disable = false
            }
        }

        return disable;
    }

    handleChange = (event) => {
        const { name, value } = event.target;

        this.setState(prevState => ({
            ...prevState,
            voucher: {
                ...prevState.voucher,
                [name]: value

            },
        }));
    }

    handleFilterChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleFilterRangeChange = ({ startDate, endDate }) => {
        this.setState({ filterStartDate: startDate, filterEndDate: endDate });
    }

    handleDateRangeChange = (startDate, endDate) => {
        this.setState(prevState => ({
            ...prevState,
            voucher: {
                ...prevState.voucher,
                validFrom: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
                validUntil: endDate ? moment(endDate).format("YYYY-MM-DD") : null

            },
        }));
    }

    openQrCodeModal = () => {
        this.setState({ qrcodeModal: true });
    }

    toggleRechargeModal = () => {
        this.setState(prevState => ({ rechargeModal: !prevState.rechargeModal }));
    }

    toggleRegistOnPmsModal = () => {
        this.setState(prevState => ({ registOnPmsModal: !prevState.registOnPmsModal }));
    }

    addRecharge = (newRecharge) => {
        this.setState(prevState => ({
            rechargeModal: false,
            voucher: {
                ...prevState.voucher,
                voucherValue: parseFloat(prevState.voucher.voucherValue ?? 0) + parseFloat(newRecharge.voucherValue ?? 0),
                voucherRecharges: [...(prevState.voucher.voucherRecharges || []), newRecharge]
            }
        }));
    }

    render() {
        const { currentVoucherStatus, qrcodeModal, voucher, rechargeModal } = this.state;
        const orderedCountries = getOrderedCountries();
        const redeemsList = this.state.voucher.redeems || [];
        const hotelOptions = [...new Set(redeemsList.map(el => el.hotelName).filter(Boolean))].sort().map(hotel => ({ value: hotel, label: hotel }));
        const filteredRedeems = redeemsList.filter(el => {
            if (this.state.filterHotel && el.hotelName !== this.state.filterHotel) return false;

            if (this.state.filterAmount) {
                const amountFilterNum = parseFloat(this.state.filterAmount);
                if (isNaN(amountFilterNum) || parseFloat(el.amount) !== amountFilterNum) return false;
            }

            if (this.state.filterStartDate || this.state.filterEndDate) {
                const elDate = el.businessDate ? moment(el.businessDate.substring(0, 10)) : null;
                if (!elDate) return false;

                if (this.state.filterStartDate && elDate.isBefore(this.state.filterStartDate, 'day')) return false;
                if (this.state.filterEndDate && elDate.isAfter(this.state.filterEndDate, 'day')) return false;
            }

            return true;
        });

        let refund = this.state.voucher.refunds && this.state.voucher.refunds.reduce((acc, cur) => acc + cur.amount, 0).toFixed(2);
        let redeems = this.state.voucher.redeems && this.state.voucher.redeems.reduce((acc, cur) => acc + cur.amount, 0).toFixed(2);

        if (this.state.accessDenied) {
            return (
                <StyledCard title='VoucherOperationDetails.VoucherDetails' block={this.state.block} error={this.state.error}>
                    <Row className="my-5">
                        <Col className="text-center">
                            <i className="fa-solid fa-lock fa-2x mb-3" />
                            <h5><FormattedMessage id="VoucherOperationDetails.AccessDenied" /></h5>
                            <p><FormattedMessage id="VoucherOperationDetails.AccessDeniedText" /></p>
                            <Button className="btn-host btn-sm" onClick={() => this.props.history.push('/OperationManagement')}>
                                <FormattedMessage id="VoucherOperationDetails.BackToAllCards" />
                            </Button>
                        </Col>
                    </Row>
                </StyledCard>
            );
        }


        return (
            <>
                <StyledCard title='VoucherOperationDetails.VoucherDetails' block={this.state.block} error={this.state.error}>
                    <Modal isOpen={this.state.modal} toggle={_ => this.toggleModal(null)} fade={false} className="modal-xl" >
                        <ModalBody className="modal-xl p-0">
                            <AddRedeem
                                voucher={this.state.voucher}
                                refresh={() => this.getVouherDetails(this.props.match.params.id)}
                                redeem={this.state.redeem}
                            />
                        </ModalBody>
                    </Modal>

                    {
                        this.state.editClientModal ?
                            <EditClientModal
                                isOpen={this.state.editClientModal}
                                toggle={this.toggleEditClient}
                                profileId={this.state.voucher.profileId}
                                voucherId={this.state.voucher.id}
                                updateClientData={this.updateClientData}
                                history={this.props.history}
                            />
                            :
                            <div />
                    }

                    {
                        document.getElementById('qrcode') ?
                            <Modal isOpen={this.state.modalPrint} toggle={this.toggleModalPrint} fade={false} className="modal-xl" >
                                <ModalHeader toggle={this.toggleModalPrint} className="p-2">

                                </ModalHeader>
                                <ModalBody className="modal-xl p-0">
                                    {/*<PrintableVoucher language={this.state.language} voucher={this.state.voucher} qrcode={document.getElementById('qrcode').toDataURL()} voucherId={this.props.match.params.id} />*/}
                                    <PrintableVoucher language={this.state.language} voucher={this.state.voucher} voucherId={this.props.match.params.id} />
                                </ModalBody>
                            </Modal>
                            :
                            ''
                    }
                    {
                        this.state.refoundModal ?
                            <RefoundModal
                                isOpen={this.state.refoundModal}
                                toggle={this.toggleRefoundModal}
                                redeem={this.state.redeem}
                                voucher={this.state.voucher}
                                refresh={() => this.getVouherDetails(this.props.match.params.id)}
                                maxQuantity={this.state.maxQuantity}
                            />
                            :
                            <div />
                    }

                    {
                        this.state.registOnPmsModal ?
                            <RegistVoucherOnPmsModal
                                isOpen={this.state.registOnPmsModal}
                                toggle={this.toggleRegistOnPmsModal}
                                voucher={this.state.voucher}
                                onRegistered={() => this.getVouherDetails(this.props.match.params.id)}
                            />
                            :
                            <div />
                    }

                    {qrcodeModal ?
                        <QrCodeModal
                            isOpen={qrcodeModal}
                            toggle={() => this.setState({ qrcodeModal: false })}
                            voucherId={this.state.voucher.voucherId}
                            voucherIdFirst8={this.state.voucher.voucherIdFirst8}
                            intl={this.props.intl}
                        />
                    : ''}

                    <Form onSubmit={this.saveVoucher}>
                        <Row className="mb-2">
                            <Col className="d-flex align-items-center">
                                <div>
                                    {
                                        orderedCountries.map((country, key) =>
                                            <span key={key}>
                                                <div
                                                    className={`flag-icon flag-icon-${country.toLowerCase()} mb-2 px-2 mr-1`}
                                                    style={{ filter: this.state.language !== country ? 'brightness(50%)' : '' }}
                                                    onClick={() => this.setLanguage(country)}
                                                />
                                            </span>
                                        )
                                    }
                                </div>
                            </Col>
                            <Col className="text-right d-flex justify-content-end">
                                <Authorization
                                    perform="voucher:registOnPms"
                                    yes={() => (
                                        currentVoucherStatus === 'created' && voucher.salePrice > 0 && !voucher.invoiceReference && !voucher.onlinePaymentId ?
                                            <div>
                                                <Button type="button" className="btn-host btn-sm mr-1" id="registOnPmsTooltip" onClick={this.toggleRegistOnPmsModal}>
                                                    <i className="fa-regular fa-share-from-square" />
                                                </Button>
                                                <UncontrolledTooltip placement="bottom" target="registOnPmsTooltip">
                                                    <FormattedMessage id="VoucherOperationDetails.RegistOnPms" />
                                                </UncontrolledTooltip>
                                            </div>
                                            :
                                            <div></div>
                                    )}
                                    no={() => <div></div>}
                                />
                                <Authorization
                                    perform="voucherDetails:sendNotif"
                                    yes={() => (
                                        <div>
                                            <Button className="btn-host btn-sm mr-1" id="emailTooltip"
                                                disabled={(this.state.voucher.isGift === true && !this.state.voucher.recipient) || (this.state.voucher.isGift === false && !this.state.voucher.email)}
                                                onClick={this.sendNotification.bind(this)}
                                            >
                                                <i className="fa-regular fa-envelope"></i>
                                            </Button>
                                            <UncontrolledTooltip placement="bottom" target="emailTooltip">
                                                <FormattedMessage id="VoucherOperationDetails.SendEmail" />
                                            </UncontrolledTooltip>
                                        </div>
                                    )}
                                    no={() => <div></div>}
                                />
                                <Button className="btn-host btn-sm mr-1" id="printTooltip" onClick={this.viewVoucher.bind(this)}>
                                    <i className="fa-solid fa-print " />
                                </Button>
                                <UncontrolledTooltip placement="bottom" target="printTooltip">
                                    <FormattedMessage id="VoucherOperationDetails.PrintVoucher" />
                                </UncontrolledTooltip>
                                <Authorization
                                    perform="voucherDetails:save"
                                    yes={() => (
                                        <div>
                                            <Button className="btn-host btn-sm" id="saveChangesTooltip" type="submit"> <i className="fa-solid fa-floppy-disk " /></Button>
                                            <UncontrolledTooltip placement="bottom" target="saveChangesTooltip">
                                                <FormattedMessage id="VoucherOperationDetails.SaveChanges" />
                                            </UncontrolledTooltip>
                                        </div>
                                    )}
                                    no={() => <div></div>}
                                />
                            </Col>
                        </Row>
                        <hr className="my-1" />
                        {
                            this.state.voucher.voucherId ?
                                    <Row>
                                        <Col>
                                            <h4>
                                                {this.state.voucher.voucherType && this.state.voucher.voucherType.code}
                                            </h4>
                                        </Col>
                                        <Col className="text-right">
                                            <span className='pointer' onClick={this.openQrCodeModal}>
                                                <RenderVoucherCode 
                                                    voucherId={this.state.voucher.voucherId}
                                                    intl={this.props.intl}
                                                />
                                            </span>                                    
                                        </Col>
                                    </Row>
                                : ''
                        }
                        <Row className="mb-3">
                            <Col className="col-2"><FormattedMessage id="VoucherOperationDetails.SoldAt" /></Col>
                            <Col className="col-4">{this.state.voucher.hotelName}</Col>
                            {this.state.voucher.onlinePaymentId ?
                                <>
                                    <Col className="col-2"><FormattedMessage id="VoucherOperationDetails.OnlineSale" /></Col>
                                    <Col className="col-4"><a style={{ cursor: "pointer", color: "blue" }} onClick={() => this.onlineSaleDetail()}>{this.state.voucher.onlinePaymentId}</a></Col>
                                </>
                                : ''}
                        </Row>
                        <Row className="mb-4">
                            {this.state.voucher.voucherType ?
                                <>
                                    <Col className="col-2"><FormattedMessage id="VoucherOperationDetails.CardType" /></Col>
                                    <Col className="col-4"><a style={{ cursor: "pointer", color: "blue" }} onClick={() => this.voucherTypeDetail()}>{this.state.voucher.voucherType.code}</a></Col>
                                </>
                                : ''}
                            {global.modules?.some(m => m === "VoucherPIN") && CheckAuthorization("voucherPin:view") && this.state.voucher.pin ?
                                <>
                                    <Col className="col-2 ">PIN</Col>
                                    <Col className="col-4">{this.state.voucher.pin}</Col>
                                </>
                            : ''}
                        </Row>

                        <Row className="mb-2">
                            <Col className="col-2">
                                <Label><FormattedMessage id="VoucherOperationDetails.CardId" /></Label>
                            </Col>
                            <Col className="col-4">
                                <FormattedMessage id="VoucherOperationDetails.CardId" >
                                    {
                                        placeholder => <Input type="text" placeholder={placeholder} readOnly value={getRightVoucherId(this.state.voucher.voucherId, this.state.voucher.voucherIdFirst8) ?? ''} />
                                    }
                                </FormattedMessage>
                            </Col>
                            <Col className="col-2">
                                <Label><FormattedMessage id="VoucherOperationDetails.Number" /></Label>
                            </Col>
                            <Col className="col-4">
                                <FormattedMessage id="VoucherOperationDetails.Number" >
                                    {
                                        placeholder => <Input type="text" placeholder={placeholder} readOnly value={this.state.voucher.ordinal ?? ''} />
                                    }
                                </FormattedMessage>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col className="col-2">
                                <Label><FormattedMessage id="VoucherOperationDetails.SalePrice" /></Label>
                            </Col>
                            <Col className="col-4">
                                <FormattedMessage id="VoucherOperationDetails.PayedAmount" >
                                    {
                                        placeholder => <Input type="number" placeholder={placeholder} readOnly value={this.state.voucher.salePrice ?? ''} />
                                    }
                                </FormattedMessage>
                            </Col>
                            <Col className="col-2">
                                <Label><FormattedMessage id="VoucherOperationDetails.VoucherAmount" /></Label>
                            </Col>
                            <Col className="col-4">
                                <FormattedMessage id="VoucherOperationDetails.VoucherAmount" >
                                    {
                                        placeholder => <Input type="number" placeholder={placeholder} readOnly value={this.state.voucher.voucherValue ?? ''} />
                                    }
                                </FormattedMessage>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col className="col-2">
                                <Label><FormattedMessage id="VoucherOperationDetails.Vality" /></Label>
                            </Col>
                            <Col className="col-4">
                                <DateRangePicker
                                    startDateId="vouchersValidFrom"
                                    startDate={this.state.voucher && this.state.voucher.validFrom ? moment(this.state.voucher.validFrom) : null}
                                    isOutsideRange={day => day < moment()}
                                    endDate={this.state.voucher && this.state.voucher.validUntil ? moment(this.state.voucher.validUntil) : null}
                                    endDateId="vouchersValidUntil"
                                    onDatesChange={({ startDate, endDate }) => this.handleDateRangeChange(startDate, endDate)}
                                    focusedInput={this.state.focusedInput}
                                    onFocusChange={focusedInput => this.setState({ focusedInput })}
                                    small={true}
                                    required
                                    numberOfMonths={2}
                                    showDefaultInputIcon={true}
                                    disabled={!CheckAuthorization("voucherDetails:editValidUntil") || currentVoucherStatus === 'expiredWithInvoice'}
                                />
                            </Col>
                            <Col className="col-2">
                                <Label><FormattedMessage id="VoucherOperationDetails.Status" /></Label>
                            </Col>
                            <Col className="col-4">
                                <CustomSelect 
                                    options={getStatus(false)} 
                                    value={getStatus(true).find(el => el.value === this.state.voucher.status) ?? null} 
                                    name={'status'} 
                                    onChange={this.updateFilterCombo.bind(this)} 
                                    placeholder={<FormattedMessage id="VoucherOperationDetails.Status" />} 
                                    isDisabled={currentVoucherStatus === 'expiredWithInvoice'}
                                />
                            </Col>
                        </Row>
                        {this.state.voucher.status === 'cancelled' && global.modules?.includes('CancellationReason') &&
                            <Row className="mb-2">
                                <Col className="col-2">
                                    <Label><FormattedMessage id="VoucherOperationDetails.CancellationReason" /></Label>
                                </Col>
                                <Col className="col-4">
                                    <SelectCancellationReason
                                        name="cancellationReasonId"
                                        value={this.state.voucher.cancellationReasonId ?? null}
                                        onChangeFunc={(combo) => this.setState(prevState => ({ voucher: { ...prevState.voucher, cancellationReasonId: combo ? combo.value : null } }))}
                                        placeholder={<FormattedMessage id="VoucherOperationDetails.CancellationReason" />}
                                        isClearable
                                        required
                                    />
                                </Col>
                                <Col className="col-2">
                                    <Label><FormattedMessage id="VoucherOperationDetails.CancellationDescription" /></Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="VoucherOperationDetails.CancellationDescription">
                                        {placeholder =>
                                            <Input
                                                type="textarea"
                                                name="cancellationReasonDescription"
                                                placeholder={placeholder}
                                                value={this.state.voucher.cancellationReasonDescription ?? ''}
                                                onChange={this.handleChange}
                                                maxLength={500}
                                                rows={2}
                                            />
                                        }
                                    </FormattedMessage>
                                    <div className="text-right font_size_xxs text-muted">
                                        {(this.state.voucher.cancellationReasonDescription ?? '').length}/500
                                    </div>
                                </Col>
                            </Row>
                        }
                        <Row className="mb-2">
                            <Col className="col-2">
                                <Label><FormattedMessage id="VoucherOperationDetails.CreatedAt" /></Label>
                            </Col>
                            <Col className="col-4">
                                <FormattedMessage id="VoucherOperationDetails.CreatedAt">
                                    {
                                        placeholder => <Input type="text" placeholder={placeholder} readOnly value={moment(this.state.voucher.createdAt).format("YYYY-MM-DD")} />
                                    }
                                </FormattedMessage>
                            </Col>
                            <Col className="col-6">
                                {/*Room Folio ID*/}
                                {this.state.voucher.roomFolioId ?
                                    <Row>
                                        <Col className="col-4">
                                            <Label>
                                                <FormattedMessage id={"VoucherOperationDetails.EmissionFolio"} />
                                            </Label>
                                        </Col>
                                        <Col className="col-8">
                                            <Input
                                                type="text"
                                                name="roomFolioId"
                                                value={this.state.voucher.roomFolioId}
                                                disabled
                                            />
                                        </Col>
                                    </Row>
                                :
                                    <>
                                        {/*Ou mostrar Invoice Reference*/}
                                        <Row>
                                            <Col className="col-4">
                                                <Label>
                                                    <FormattedMessage id={this.state.voucher.roomFolioId ? "VoucherOperationDetails.EmissionFolio" : "VoucherOperationDetails.InvoiceReference"} />
                                                </Label>
                                            </Col>
                                            <Col className="col-7">
                                                <FormattedMessage id="VoucherOperationDetails.InvoiceReference" >
                                                    {placeholder =>
                                                        <Input
                                                            type="text"
                                                            name="invoiceReference"
                                                            placeholder={placeholder}
                                                            value={this.state.voucher.invoiceReference ?? ''}
                                                            onChange={this.handleChange}
                                                            maxLength={50}
                                                        />
                                                    }
                                                </FormattedMessage>
                                            </Col>
                                            <Col className="col-1 text-right">
                                                <Button className="btn-sm btn-host mt-1" id="viewReceiptTooltip" disabled={this.state.voucher.pmsInvoiceURL == null || this.state.voucher.pmsInvoiceURL == undefined} onClick={() => window.open(this.state.voucher.pmsInvoiceURL, "_blank")} >
                                                    <i className="fa-solid fa-receipt" ></i> 
                                                </Button>
                                                <UncontrolledTooltip placement="bottom" target="viewReceiptTooltip">
                                                    <FormattedMessage id="OnlineSalesDetail.ViewReceipt" />
                                                </UncontrolledTooltip>
                                            </Col>
                                        </Row>
                                        {this.state.voucher.expiredInvoiceURL ?
                                            <Row className="mt-2">
                                                <Col className="col-4">
                                                    <Label><FormattedMessage id="VoucherOperationDetails.ExpiredVoucherInvoice" /></Label>
                                                </Col>
                                                <Col className="col-7">
                                                    <FormattedMessage id="VoucherOperationDetails.ExpiredVoucherInvoice" >
                                                        {placeholder => 
                                                            <Input
                                                                type="text" 
                                                                name="expiredInvoiceReference"
                                                                placeholder={placeholder} 
                                                                value={this.state.voucher.expiredInvoiceReference ?? ''} 
                                                                disabled
                                                            />
                                                        }
                                                    </FormattedMessage>
                                                </Col>
                                                <Col className="col-1 text-right">
                                                    <Button className="btn-sm btn-host mt-1" id="viewExpiredInvoice" onClick={() => window.open(this.state.voucher.expiredInvoiceURL, "_blank")} >
                                                        <i className="fa-solid fa-receipt" ></i> 
                                                    </Button>
                                                    <UncontrolledTooltip placement="bottom" target="viewExpiredInvoice">
                                                        <FormattedMessage id="OnlineSalesDetail.ViewReceipt" />
                                                    </UncontrolledTooltip>
                                                </Col>
                                            </Row>
                                        : ''}
                                    </>
                                }
                            </Col>
                        </Row>

                        <Row className="mb-2">
                            <Col className="col-2">
                                <Label><FormattedMessage id="VoucherOperationDetails.IssueCode" /></Label>
                            </Col>
                            <Col className="col-4">
                                <FormattedMessage id="VoucherOperationDetails.IssueCode" >
                                    {placeholder => 
                                        <Input
                                            type="text"
                                            name="issueCode"
                                            placeholder={placeholder}
                                            value={this.state.voucher.issueCode ?? ''}
                                            onChange={this.handleChange}
                                            maxLength={50}
                                        />
                                    }
                                </FormattedMessage>
                            </Col>
                            
                            {global.modules?.some(m => m === "VoucherRFID") ?
                                <>
                                    <Col className="col-2">
                                        <Label><FormattedMessage id="VoucherOperationDetails.RfId" /></Label>
                                    </Col>
                                    <Col className="col-4">
                                        <FormattedMessage id="VoucherOperationDetails.RfId" >
                                            {
                                                placeholder => <Input
                                                    type="text"
                                                    name="rfId"
                                                    placeholder={placeholder}
                                                    value={this.state.voucher.rfId ?? ''}
                                                    onChange={this.handleChange}
                                                    maxLength={100}
                                                />
                                            }
                                        </FormattedMessage>
                                    </Col>
                                </>
                            : ''}
                        </Row>
                        <Row className="mb-2">
                            <Col className="col-2">
                                <Label><FormattedMessage id="VoucherOperationDetails.Notes" /></Label>
                            </Col>
                            <Col className="col-10">
                                <FormattedMessage id="VoucherOperationDetails.Notes" >
                                    {placeholder => 
                                        <Input 
                                            type="textarea" 
                                            placeholder={placeholder}
                                            value={this.state.voucher.notes ?? ''} 
                                            name="notes"
                                            onChange={this.handleChange} 
                                            disabled={currentVoucherStatus === 'expiredWithInvoice'}
                                        />
                                    }
                                </FormattedMessage>
                            </Col>
                        </Row>
                    </Form>

                    {this.state.voucher.isGift || (this.state.voucher.from && this.state.voucher.to) ?
                        <div>
                            <Row className="mt-4">
                                <Col>
                                    <h4><FormattedMessage id="VoucherOperationDetails.GiftInfo" /></h4>
                                </Col>
                            </Row>
                            <hr className="my-1 mb-3" />
                            <Row className="mb-2">
                                <Col className="col-2">
                                    <Label><FormattedMessage id="VoucherManagement.From" /></Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="VoucherManagement.From" >
                                        {
                                            placeholder => <Input type="text" placeholder={placeholder} readOnly value={this.state.voucher.from} />
                                        }
                                    </FormattedMessage>
                                </Col>
                                <Col className="col-2">
                                    <Label><FormattedMessage id="VoucherManagement.To" /></Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="VoucherManagement.To" >
                                        {
                                            placeholder => <Input type="text" placeholder={placeholder} readOnly value={this.state.voucher.to} />
                                        }
                                    </FormattedMessage>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col className="col-2">
                                    <Label><FormattedMessage id="VoucherManagement.Sender" /></Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="VoucherManagement.Sender" >
                                        {
                                            placeholder => <Input type="text" placeholder={placeholder} readOnly value={this.state.voucher.sender} />
                                        }
                                    </FormattedMessage>
                                </Col>
                                <Col className="col-2">
                                    <Label><FormattedMessage id="VoucherManagement.Recipient" /></Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="VoucherManagement.Recipient" >
                                        {
                                            placeholder => <Input type="text" placeholder={placeholder} readOnly value={this.state.voucher.recipient} />
                                        }
                                    </FormattedMessage>
                                </Col>
                            </Row>

                            <Row className="mb-2">
                                <Col className="col-2">
                                    <Label><FormattedMessage id="VoucherOperationDetails.Message" /></Label>
                                </Col>
                                <Col className="col-10">
                                    <FormattedMessage id="VoucherOperationDetails.Message" >
                                        {
                                            placeholder => <Input type="textarea" placeholder={placeholder} readOnly value={this.state.voucher.message ?? ''} />
                                        }
                                    </FormattedMessage>
                                </Col>
                            </Row>
                        </div>
                        : ''}

                    <Row className="mt-4">
                        <Col>
                            <h5><FormattedMessage id="VoucherOperationDetails.Client" /></h5>
                        </Col>
                        <Authorization
                            perform="voucherDetails:client:edit"
                            yes={() => (
                                <Col className="text-right">
                                    <Button className="btn-host btn-sm" onClick={this.editClient.bind(this)}>
                                        <i className="fa fa-pen-to-square" />
                                    </Button>
                                </Col>
                            )}
                            no={() => <div></div>}
                        />
                    </Row>
                    <hr className="mt-1 mb-2" />
                    <Row>
                        <Col className="col-2"><Label><FormattedMessage id="VoucherOperationDetails.Name" /></Label></Col>
                        <Col>
                            <FormattedMessage id="VoucherOperationDetails.Name" >
                                {
                                    placeholder => <Input type="text" placeholder={placeholder} readOnly value={this.state.voucher.name} />
                                }
                            </FormattedMessage>
                        </Col>
                        <Col className="col-2"><Label>Email</Label></Col>
                        <Col>
                            <Input type="text" placeholder="Email" readOnly value={this.state.voucher.email || ''} />
                        </Col>
                    </Row>

                </StyledCard>
                <div className="mb-2" />
                <StyledCard icon={'fa-solid fa-wallet'} title={'VoucherOperationDetails.UsageSummary'} block={this.state.block}>
                    {this.state.voucher.voucherType && this.state.voucher.voucherType.isPaymentMode === true ?
                        <Row className="mt-2">
                            <Col>
                                <FormattedMessage id="VoucherOperationDetails.CardAmount" /> {this.state.voucher.voucherValue}
                            </Col>
                            <Col>
                                <FormattedMessage id="VoucherOperationDetails.Refunded" />  {refund ? refund : 0}</Col>
                            <Col>
                                <FormattedMessage id="VoucherOperationDetails.Used" /> {redeems ? redeems : 0}
                            </Col>
                            <Col>
                                <b><FormattedMessage id="VoucherOperationDetails.Left" /> {(this.state.voucher.voucherValue - refund - redeems).toFixed(2)}</b>
                            </Col>
                        </Row>
                        : <Row>
                            <Col>
                                <Row>
                                    {this.state.voucher.voucherType && this.state.voucher.voucherType.voucherRebates.map((el, k) =>
                                        <Col key={k} className="col-3">
                                            <Card>
                                                <CardBody>
                                                    <div className="font-weight-bold"><RichTextView value={el.description} /></div>
                                                    <Row>
                                                        <Col><FormattedMessage id="VoucherOperationDetails.Total" />  {el.quantity}</Col>
                                                        <Col><FormattedMessage id="VoucherOperationDetails.Used" />  {this.state.voucher.redeems != undefined && this.state.voucher.redeems.filter(x => x.rebateId === el.id).reduce((acc, cur) => acc + cur.quantity, 0)}</Col>
                                                        <Col><FormattedMessage id="VoucherOperationDetails.Left" />  <b>{el.quantity - (this.state.voucher.redeems != undefined && this.state.voucher.redeems.filter(x => x.rebateId === el.id).reduce((acc, cur) => acc + cur.quantity, 0))}</b></Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>

                                        </Col>
                                    )}
                                </Row>
                            </Col>
                        </Row>}
                </StyledCard>
                <div className="mb-2" />
                <StyledCard icon={'fa-solid fa-bars'} title={'VoucherOperationDetails.Redeems'} block={this.state.block}>
                    <Row className="mt-2 align-items-center">
                        {this.state.voucher.dailyValueLimit ?
                            <Col className="font_size_xxs">      
                                <span><FormattedMessage id="EditVoucher.DailyValueLimit" />: </span>
                                <span>
                                    {this.state.voucher.dailyValueLimit}
                                </span>
                            </Col>
                        : ''}
                        <Col className="text-right">
                            <Authorization
                                perform="redeems:add"
                                yes={() => (
                                    <div>
                                        <Button className="btn-host btn-sm" id="redeemTooltip" onClick={_ => this.toggleModal(null)} disabled={currentVoucherStatus === 'expiredWithInvoice'}>
                                            <i className="fa-solid fa-plus " />
                                        </Button>
                                        <UncontrolledTooltip placement="bottom" target="redeemTooltip">
                                            <FormattedMessage id="VoucherOperationDetails.AddManualRedeem" />
                                        </UncontrolledTooltip>
                                    </div>
                                )}
                                no={() => <div></div>}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col sm="2">
                            <CustomSelect
                                options={hotelOptions}
                                value={hotelOptions.find(opt => opt.value === this.state.filterHotel)}
                                onChange={(val) => this.setState({ filterHotel: val ? val.value : '' })}
                                placeholder={<FormattedMessage id="VoucherOperationDetails.Hotel" />}
                                isClearable={true}
                            />
                        </Col>
                        {this.state.voucher.voucherType && this.state.voucher.voucherType.isPaymentMode === true ?
                            <Col sm="2">
                                <FormattedMessage id="VoucherOperationDetails.Amount">
                                    {placeholder => <Input type="number" name="filterAmount" placeholder={placeholder} value={this.state.filterAmount} onChange={this.handleFilterChange} />}
                                </FormattedMessage>
                            </Col>
                        : ''}
                        <Col sm="2">
                            <DateRangePicker
                                startDate={this.state.filterStartDate}
                                startDateId="filter_start_date"
                                endDate={this.state.filterEndDate}
                                endDateId="filter_end_date"
                                onDatesChange={this.handleFilterRangeChange}
                                focusedInput={this.state.filterRangeFocused}
                                onFocusChange={focusedInput => this.setState({ filterRangeFocused: focusedInput })}
                                numberOfMonths={1}
                                isOutsideRange={() => false}
                                displayFormat="DD-MM-YYYY"
                                small={true}
                                showDefaultInputIcon={true}
                                isClearable={true}
                            />
                        </Col>
                    </Row>
                    {this.state.voucher.voucherType && this.state.voucher.voucherType.isPaymentMode === true ?
                                <Row className="mt-2">
                                    <Col>
                                    <Table size="sm" style={{ tableLayout: 'fixed', width: '100%' }}>
                                        <thead style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                                            <tr style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                                                <th><FormattedMessage id="VoucherOperationDetails.Hotel" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.Invoice" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.RedeemReference" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.Amount" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.Date" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.Notes" /></th>
                                                <th className="text-center"><FormattedMessage id="VoucherOperationDetails.Revoke" /></th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ display: 'block', maxHeight: '60vh', overflowY: 'auto' }}>
                                            {filteredRedeems && filteredRedeems.map((el, k) => {
                                                const isPositiveAmount = el.amount > 0;

                                                return (
                                                    <tr key={k} className="pointer" style={{ display: 'table', width: '100%', tableLayout: 'fixed' }} onClick={() => { if (isPositiveAmount) this.toggleModal(el) }}>
                                                        <td>{el.hotelName}</td>
                                                        <td>{el.invoice}</td>
                                                        <td>{el.targetReference}</td>
                                                        <td className={el.amount < 0 ? 'text-danger font-weight-bold' : ''}> {el.amount}</td>
                                                        <td>{el.businessDate.substring(0, 10)}</td>
                                                        <td>{el.notes}</td>
                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                            {isPositiveAmount > 0 ?
                                                                <Button className="btn-host btn-sm" onClick={_ => this.toggleRefoundModal(el)} disabled={currentVoucherStatus === 'expiredWithInvoice'}>
                                                                    <i className="fa-solid fa-rotate-left" />
                                                                </Button>
                                                                : ''}
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                            :
                            <Row className="mt-2">
                                <Col>
                                    <Table size="sm" style={{ tableLayout: 'fixed', width: '100%' }}>
                                        <thead style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                                            <tr style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                                                <th><FormattedMessage id="VoucherOperationDetails.RebateCode" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.Hotel" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.Invoice" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.RedeemReference" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.Quantity" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.Date" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.Notes" /></th>
                                                <th className="text-center"><FormattedMessage id="VoucherOperationDetails.Refund" /></th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ display: 'block', maxHeight: '60vh', overflowY: 'auto' }}>
                                            {filteredRedeems && filteredRedeems.map((el, k) => {
                                                const isPositiveQuantity = el.quantity > 0;

                                                return (
                                                    <tr key={k} className="pointer" style={{ display: 'table', width: '100%', tableLayout: 'fixed' }} onClick={() => { if (isPositiveQuantity) this.toggleModal(el) }}>
                                                        <td>{el.rebateCode}</td>
                                                        <td>{el.hotelName}</td>
                                                        <td>{el.invoice}</td>
                                                        <td>{el.targetReference}</td>
                                                        <td className={el.quantity < 0 ? 'text-danger font-weight-bold' : ''}>{el.quantity}</td>
                                                        <td>{el.businessDate.substring(0, 10)}</td>
                                                        <td>{el.notes}</td>
                                                        <td className="text-center">
                                                                {isPositiveQuantity ?
                                                                <Button className="btn-host btn-sm" onClick={_ => this.toggleRefoundModal(el)} disabled={this.disableServiceRefund(el)}>
                                                                    <i className="fa-solid fa-rotate-left" />
                                                                </Button>
                                                                : ''}
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                    }
                </StyledCard>
                {voucher.voucherType?.isPaymentMode && voucher.voucherType?.isRechargable ? 
                    <>
                        {rechargeModal && 
                            <AddRechargeModal 
                                isOpen={rechargeModal}
                                toggleModal={this.toggleRechargeModal}
                                voucherId={this.props.match.params.id}
                                addRecharge={this.addRecharge}
                            />
                        }

                        <div className="mb-2" />
                        <StyledCard icon={'fa-solid fa-hand-holding-dollar'} title={'VoucherOperationDetails.Recharges'} block={this.state.block}>
                            {voucher.voucherType.allowPartialRedeem && currentVoucherStatus !== 'expiredWithInvoice' && currentVoucherStatus !== 'cancelled' ?
                                <Authorization
                                    perform="recharges:add"
                                    yes={() => (
                                        <Row className="mt-2 align-items-center">
                                            <Col className="text-right">
                                                <div>
                                                    <Button className="btn-host btn-sm" id="rechargeTooltip" onClick={_ => this.toggleRechargeModal()}>
                                                        <i className="fa-solid fa-plus " />
                                                    </Button>
                                                    <UncontrolledTooltip placement="bottom" target="rechargeTooltip">
                                                        <FormattedMessage id="VoucherOperationDetails.AddRecharge" />
                                                    </UncontrolledTooltip>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                    no={() => <div></div>}
                                />
                            : ''}

                            <Row className="mt-2">
                                <Col>
                                    <Table size="sm">
                                        <thead>
                                            <tr>
                                                <th><FormattedMessage id="VoucherOperationDetails.Date" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.InvoiceReference" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.SalePrice" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.Amount" /></th>
                                                <th><FormattedMessage id="VoucherOperationDetails.Notes" /></th>
                                                <th width='120px'><FormattedMessage id="VoucherOperationDetails.PmsInvoice" /></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {voucher.voucherRecharges && voucher.voucherRecharges.map((el, k) => {
                                                return (
                                                    <tr key={k}>
                                                        <td>{el.createdAt ? moment(el.createdAt).format('YYYY-MM-DD') : ''}</td>
                                                        <td>{el.invoiceReference}</td>
                                                        <td>{el.salePrice}</td>
                                                        <td>{el.voucherValue}</td>
                                                        <td>{el.note}</td>
                                                        <td width='120px' className='text-center'>
                                                            {el.pmsInvoiceUrl ?                                                                
                                                                <Button className="btn-sm btn-host mr-1" onClick={() => window.open(el.pmsInvoiceUrl, "_blank")} >
                                                                    <i className="fa-solid fa-receipt" ></i> 
                                                                </Button>
                                                            : ''}
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </StyledCard>
                    </>
                : ''}
                <div className="mb-2" />
                {
                    this.state.voucher.refunds ?
                        <StyledCard icon={'fa-solid fa-rotate-left'} title={'VoucherOperationDetails.Refunds'} block={this.state.block}>

                            <>
                                <Row className="mt-2">
                                    <Col>
                                        <Table size="sm">
                                            <thead>
                                                <tr>
                                                    <th><FormattedMessage id="VoucherOperationDetails.Date" /></th>
                                                    <th><FormattedMessage id="VoucherOperationDetails.Amount" /></th>
                                                    <th><FormattedMessage id="VoucherOperationDetails.Reason" /></th>
                                                    <th><FormattedMessage id="VoucherOperationDetails.Notes" /></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.voucher.refunds && this.state.voucher.refunds.map((el, k) =>
                                                    <tr key={k}>
                                                        <td>{el.createdAt ? moment(el.createdAt).format('YYYY-MM-DD') : ''}</td>
                                                        <td>{el.amount}</td>
                                                        <td>{el.reason}</td>
                                                        <td>{el.notes}</td>

                                                    </tr>
                                                )}


                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>

                            </>

                        </StyledCard>
                        : ''}
                <div className="mt-2 mb-4" >
                    <NotificationCard icon={'fa-solid fa-at'} block={this.state.block} list={this.state.voucher.notifications} />
                </div>

            </>


        );
    }
}
export default injectIntl(VoucherOperationDetails);


const QrCodeModal = ({ isOpen, toggle, voucherId, voucherIdFirst8, intl }) => {
    const qrcodeRef = useRef(null);

    const printQrCode = () => {
        const printWindow = window.open('', 'PRINT', 'height=600,width=800');
        let contentToPrint = '';

        // Busca SVG ou canvas dentro do ref
        const svg = qrcodeRef.current?.querySelector('svg');
        const canvas = qrcodeRef.current?.querySelector('canvas');

        if (svg) {
            contentToPrint = svg.outerHTML;
        } else if (canvas) {
            const imgData = canvas.toDataURL('image/png');
            contentToPrint = `<img src="${imgData}" />`;
        } else {
            contentToPrint = qrcodeRef.current?.outerHTML || '';
        }

        // Exibir voucherId apenas se for QRCode
        const isQrCode = global.codeGenerationType !== getCodeGenerationTypes(intl)[0].value;
        const voucherText = isQrCode ? `<div style="text-align: center;padding-top: 5px">${getRightVoucherId(voucherId, voucherIdFirst8)}</div>` : '';

        printWindow.document.body.innerHTML = `
            <div style="display: flex; flex-direction: column; align-items: center; width: 25%; height: 15%;">
                ${contentToPrint}
                ${voucherText}
            </div>
        `;

        printWindow.onafterprint = () => printWindow.close();

        setTimeout(() => {
            printWindow.focus();
            printWindow.print();
        }, 250);
    };

    const isQrCode = global.codeGenerationType !== getCodeGenerationTypes(intl)[0].value;
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="sm" centered>
            <ModalBody>
                <div className="text-right">
                    <Button className="btn-host btn-sm mr-1" onClick={printQrCode}>
                        <i className="fa-solid fa-print " />
                    </Button>
                </div>
                <div className='my-4'>
                    <div
                        id="qrcodeModalContent"
                        className="my-2 d-flex flex-column align-items-center justify-content-center"
                        ref={qrcodeRef}
                    >
                        <RenderVoucherCode voucherId={voucherId} intl={intl} qrCodeSize={80} />
                        {isQrCode && (
                            <div className="mt-2 text-center">{getRightVoucherId(voucherId, voucherIdFirst8)}</div>
                        )}
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

const RenderVoucherCode = ({ voucherId, qrCodeSize, intl }) => {
    return global.codeGenerationType === getCodeGenerationTypes(intl)[0].value ?
        <span id="qrcode">
            <Barcode value={voucherId.substring(0, 8)} />
        </span>
        :
        <QRCode value={voucherId} size={qrCodeSize ?? 80} id="qrcode" />
}